module.exports = __webpack_public_path__ + "static/04-illustration-b7d01cad0845cfc6ac0637f51ba8ac76.svg";